/* eslint-disable jsx-a11y/anchor-is-valid */
import {DefaultTitle} from '../header/page-title/DefaultTitle'
import styled from 'styled-components'

const Wrapper = styled.div``

const Toolbar1 = () => {
  return (
    <Wrapper>
      <div className='toolbar' id='kt_toolbar'>
        {/* begin::Container */}
        <div id='kt_toolbar_container' className='container-fluid'>
          <DefaultTitle />
        </div>
        {/* end::Container */}
      </div>
      {/* <CreateAppModal show={showCreateAppModal} handleClose={() => setShowCreateAppModal(false)} /> */}
    </Wrapper>
  )
}

export {Toolbar1}
